import { useHasAdminAccess } from "./useHasAdminAccess";
import { Watchlist } from "../reducer/watchList.reducer";
import { isCommunityOrReferenceType } from "../components/watchlist/WatchUtils";
import { Watchlist_Type } from "../proto/generated/watchlist";
import { useSelector } from "react-redux";
import { selectPreviewWatchlistId } from '../selectors/watchList.ts'

export const useShouldAllowAccess = () => {
  const hasAdminAccess = useHasAdminAccess();
  const preview = useSelector(selectPreviewWatchlistId);

  return (watchlist: Watchlist , isEnabled: boolean): boolean => {
    if (preview?.isActive) {
      return false;
    }
    if (hasAdminAccess){
      if(!watchlist?.type.includes(Watchlist_Type.REFERENCE)) return true ;
      return isEnabled;
    };
    return !isCommunityOrReferenceType(watchlist); 
  };
};
